import * as types from "../actionTypes/catalogFinancialAT";
import initialState from "./initialState";

export default function catalogFinancialReducer(
  state = initialState.catalogManagementUnits,
  action
) {
  switch (action.type) {
    case types.CREATE_CATALOG_FINANCIAL:
      return [...state, { ...action.course }];
    case types.UPDATE_CATALOG_FINANCIAL_SUCCESS:
      return state.map((course) =>
        course.id === action.course.id ? action.course : course
      );
    case types.LOAD_CATALOG_FINANCIAL_SUCCESS:
      return action.catalogManagementUnits;
    case types.DELETE_CATALOG_FINANCIAL_OPTIMISTIC:
      return state.filter((course) => course.id !== action.course.id);
    default:
      return state;
  }
}
